module.exports = __webpack_public_path__ + "img/vod-05.97d5c66b.gif";